import { render, staticRenderFns } from "./ssp-viewer-details.vue?vue&type=template&id=1ba0e7b2&scoped=true"
import script from "./ssp-viewer-details.vue?vue&type=script&lang=js"
export * from "./ssp-viewer-details.vue?vue&type=script&lang=js"
import style0 from "./ssp-viewer-details.vue?vue&type=style&index=0&id=1ba0e7b2&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba0e7b2",
  null
  
)

export default component.exports